import styled from "styled-components";
import { colors } from "../../../../assets";

export const FilterContainer = styled.section`
  background-color: ${colors["detail-item-background"]};
  padding: 2em;
  display: flex;
  flex-wrap: nowrap;
  gap: 1.5em;
  width: 100%;

  &.no-dates {
    justify-content: flex-end;
  }

  .selectBox {
    width: 20%;
    min-width: 150px;
  }

  .selectBox.relatedMediators {
    width: 50%;
  }

  .filter-calendar,
  .input-box-error.filter-calendar {
    width: 20%;
    min-width: 150px;
    margin-top: -10px;

    label {
      margin-bottom: 10px;
    }
  }

  .button-container {
    align-content: center;
  }
`;
